'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.blockCompany = exports.toggleFollowCompany = exports.receiveCompanyInfo = exports.fetchCompanyInfo = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _isomorphicFetch = require('isomorphic-fetch');

var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);

var _actionTypes = require('../constants/actionTypes');

var types = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var BASE_URL = '';
if (process.env.SPA_DEV) {
	BASE_URL = 'http://localhost:9001';
}

var makeActionCreator = function makeActionCreator(type) {
	for (var _len = arguments.length, argNames = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
		argNames[_key - 1] = arguments[_key];
	}

	return function () {
		for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
			args[_key2] = arguments[_key2];
		}

		var action = { type: type };

		argNames.forEach(function (arg, index) {
			action[argNames[index]] = args[index];
		});

		return action;
	};
};

var receiveCompanyInfo = makeActionCreator(types.RECEIVE_COMPANY_INFO, 'value');

var fetchCompanyInfo = function fetchCompanyInfo(companyNumber, isPublic, csrf) {
	var baseUrl = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : BASE_URL;
	return function (dispatch) {
		dispatch({
			type: types.COMPANY_INFO_REQUEST
		});
		return (0, _isomorphicFetch2.default)(baseUrl + '/employer/v2/settings/profile/' + (isPublic ? 'public/' : '') + companyNumber, {
			credentials: 'same-origin',
			method: 'get',
			headers: new Headers({
				'Content-Type': 'application/json',
				'X-CSRF-Token': csrf
			})
		}).then(function (res) {
			if (!res.ok) {
				// request error, dispatch error message
				return res.json().then(function () {
					// TODO[tim-mc] figure out if there's any custom error message relayed here
					// if not, forget trying to parse the json
					dispatch({
						type: types.COMPANY_INFO_REQUEST_ERROR
					});
				});
			}
			return res.json().then(function (response) {
				// request successful, dispatch response
				var results = response.results;

				dispatch({
					type: types.RECEIVE_COMPANY_INFO,
					value: results[0]
				});
			});
		});
	};
};

var toggleFollowCompany = function toggleFollowCompany(companyNumber, csrf, followedByUser) {
	var baseUrl = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : BASE_URL;
	return function () {
		var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch) {
			var success;
			return regeneratorRuntime.wrap(function _callee$(_context) {
				while (1) {
					switch (_context.prev = _context.next) {
						case 0:
							dispatch({
								type: types.TOGGLE_FOLLOW_COMPANY_REQUEST
							});
							_context.prev = 1;
							_context.next = 4;
							return (0, _isomorphicFetch2.default)(baseUrl + '/employer/v2/settings/profile/' + companyNumber + '/follower', {
								credentials: 'same-origin',
								method: followedByUser ? 'DELETE' : 'POST',
								headers: new Headers({
									'Content-Type': 'application/json',
									'X-CSRF-Token': csrf
								})
							}).then(function (res) {
								return res.ok;
							});

						case 4:
							success = _context.sent;

							if (success) {
								dispatch({
									type: types.TOGGLE_FOLLOW_COMPANY
								});
							}
							_context.next = 11;
							break;

						case 8:
							_context.prev = 8;
							_context.t0 = _context['catch'](1);

							dispatch({
								type: types.TOGGLE_FOLLOW_COMPANY_ERROR,
								value: _context.t0
							});

						case 11:
						case 'end':
							return _context.stop();
					}
				}
			}, _callee, undefined, [[1, 8]]);
		}));

		return function (_x3) {
			return _ref.apply(this, arguments);
		};
	}();
};

var blockCompany = function blockCompany(companyNumber, csrf) {
	var baseUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : BASE_URL;
	return function () {
		var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch) {
			return regeneratorRuntime.wrap(function _callee2$(_context2) {
				while (1) {
					switch (_context2.prev = _context2.next) {
						case 0:
							dispatch({
								type: types.BLOCK_COMPANY_REQUEST
							});
							_context2.next = 3;
							return (0, _isomorphicFetch2.default)(baseUrl + '/user/block_company/' + companyNumber, {
								credentials: 'same-origin',
								method: 'POST',
								headers: new Headers({
									'Content-Type': 'application/json',
									'X-CSRF-Token': csrf
								})
							}).then(function (res) {
								if (!((typeof res === 'undefined' ? 'undefined' : _typeof(res)) === 'object' && res.ok)) {
									dispatch({ type: types.BLOCK_COMPANY_ERROR });
									throw new Error('Block company failed');
								}
								return res.json();
							}).then(function (response) {
								var successful = response.successful;

								if (!successful) {
									var errMsg = response.messages[0];
									dispatch({ type: types.BLOCK_COMPANY_ERROR, value: errMsg });
									throw new Error('Block company failed');
								}
								dispatch({ type: types.BLOCK_COMPANY_SUCCESS });
							});

						case 3:
						case 'end':
							return _context2.stop();
					}
				}
			}, _callee2, undefined);
		}));

		return function (_x5) {
			return _ref2.apply(this, arguments);
		};
	}();
};

exports.fetchCompanyInfo = fetchCompanyInfo;
exports.receiveCompanyInfo = receiveCompanyInfo;
exports.toggleFollowCompany = toggleFollowCompany;
exports.blockCompany = blockCompany;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(BASE_URL, 'BASE_URL', 'src/actions/index.js');

	__REACT_HOT_LOADER__.register(makeActionCreator, 'makeActionCreator', 'src/actions/index.js');

	__REACT_HOT_LOADER__.register(receiveCompanyInfo, 'receiveCompanyInfo', 'src/actions/index.js');

	__REACT_HOT_LOADER__.register(fetchCompanyInfo, 'fetchCompanyInfo', 'src/actions/index.js');

	__REACT_HOT_LOADER__.register(toggleFollowCompany, 'toggleFollowCompany', 'src/actions/index.js');

	__REACT_HOT_LOADER__.register(blockCompany, 'blockCompany', 'src/actions/index.js');
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/@workmarket/wm-company-pages-spa/build/actions/index.js
// module id = nIup
// module chunks = 62 63